import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EcommerceCategories, RemoteConfig } from '../../models';
import { RemoteConfigsServiceApi } from './remote-configs.service.api';
import { RemoteConfigsServiceMock } from './remote-configs.service.mock';

@Injectable({
  providedIn: 'root',
  useClass: environment.usingMocks ? RemoteConfigsServiceMock : RemoteConfigsServiceApi,
})
export abstract class RemoteConfigsService {
  abstract get(): Observable<RemoteConfig | null>;
  abstract getEcommerceCategories(): Promise<EcommerceCategories | null>;
}